<alert *ngIf="alert" type='{{alert.type}}' dismissible="true" (onClosed)="clearAlert()"><span
  [innerHTML]="alert.text"></span></alert>
